import {
	FETCH_RETAILER_DATA,
	FETCH_REGISTRATIONS,
	GET_RETAILERS_RANKLIST,
	TAKE_ACTION_ON_REGISTRATION,
	RESET_RETAILERS_RANKLIST,
	SHOW_ALERT,
	RESET_RETAIL_MODULE,
	RESET_RETAIL_REGISTRATIONS,
	GENERATE_QR_CODE_PDF,
	FETCH_TRANSACTION_HISTORY,
	RESET_GRAB_RETAILER,
	FETCH_ALL_DISTRIBUTOR_RETAILER_LIST,
	FETCH_ACTIVE_EXECUTIVE_UNDER_DSTR,
	CREATE_RETAIL_SCHEME,
	UPDATE_RETAIL_SCHEME,
	UPLOAD_DSTR_SUPPORT_INVOICE,
	FETCH_DSTR_SUPPORT_ENTRIES,
	FETCH_DSTR_SUPPORT_INVOICE,
	REVIEW_DSTR_INVOICE,
	UPLOAD_PRIMARY_DAY_FILE
} from "../action-types";

import {
	fetchRetailerDataSuccess,
	fetchRegistrationsSuccess,
	takeActionOnRegistrationSuccess,
	fetchRetailersRankList,
	resetRetailModule,
	getQRCodePdfSuccess,
	grabRetailerTransactionHistorySuccess,
	fetchAllRetailerDstrSuccess
} from "../mutation-types";
import ApiService from "../api-service";
import {
	DEFAULT_ERROR_MESSAGE,
	TOP,
	END,
	JEET_11_PARTNER,
	JEET_11_DISTRIBUTOR
} from "../config";
import { BASE_URL } from "../../../config";
import { getFrontendStoreType } from "../../utils";

const state = {
	retailerData: null,
	grabRetailerData: null,
	grabRetailerTransactionHistory: [],
	grabRetailerTransactionHistoryOffset: null,
	retailRegistrations: null,
	grabRetailerRank: null,
	retailersTopRankList: [],
	lastKey: null,
	allRetailerDstrList: {
		list: [],
		offset: null
	},
	retailerDataForUpdate: null
};

const initialState = Object.assign({}, state);

const actions = {
	[FETCH_RETAILER_DATA.action]: (
		{ commit, dispatch, rootState },
		{ dataKey, ...payload }
	) => {
		let endpoint = BASE_URL + "/retailer/v1.0.0/getRetailerData";
		let requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(fetchRetailerDataSuccess, {
						key: dataKey,
						value: data.response
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[FETCH_REGISTRATIONS.action]: (
		{ commit, rootState, dispatch },
		payload
	) => {
		let endpoint = BASE_URL + "/retailer/v1.0.0/getReviewFeed";
		let requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					Array.isArray(data.response.registrations)
				) {
					const { registrations } = data.response;
					commit(fetchRegistrationsSuccess, registrations);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
			});
	},

	[TAKE_ACTION_ON_REGISTRATION.action]: (
		{ commit, rootState, dispatch },
		payload
	) => {
		let endpoint = BASE_URL + "/retailer/v1.0.0/takeAction";
		let requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					commit(takeActionOnRegistrationSuccess, payload);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[GET_RETAILERS_RANKLIST.action]: (
		{ commit, dispatch, rootState },
		{ type, ...payload }
	) => {
		const endpoint = BASE_URL + "/retailer/v1.0.0/getRankings";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload,
				...(type === END ? { startFrom: rootState.retail.lastKey } : {})
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;

				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					// const { retailerRank, topRanks } = data.response;
					commit(fetchRetailersRankList, { type, ...data.response });
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[RESET_RETAILERS_RANKLIST.action]: ({ commit }) => {
		commit(fetchRetailersRankList, {
			retailerRank: null,
			topRanks: []
		});
	},

	[RESET_RETAIL_REGISTRATIONS.action]: ({ commit }) => {
		commit(fetchRegistrationsSuccess, []);
	},

	[RESET_RETAIL_MODULE.action]: ({ commit }) => {
		commit(resetRetailModule);
	},

	[GENERATE_QR_CODE_PDF.action]: (
		{ commit, dispatch, rootState },
		payload
	) => {
		const endpoint = BASE_URL + "/retailer/v1.0.0/generateQRCodePdf";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				// console.log(data);
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200 && data.response) {
					commit(getQRCodePdfSuccess, data.response);
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[FETCH_TRANSACTION_HISTORY.action]: (
		{ commit, state, rootState, dispatch },
		{ type, ...payload }
	) => {
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload,
				...(type === "end"
					? { offset: state.grabRetailerTransactionHistoryOffset }
					: {}),
				username: rootState.auth.USERNAME
			}
		};
		const endpoint =
			BASE_URL + "/retailer-payment/v1.0.0/getPaymentHistory";

		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					data.response.payments
				) {
					const { payments, offset } = data.response;
					commit(grabRetailerTransactionHistorySuccess, {
						array: payments,
						offset,
						type
					});
					return;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},

	[RESET_GRAB_RETAILER.action]: ({ commit }) => {
		commit(grabRetailerTransactionHistorySuccess, {
			array: [],
			offset: null
		});
		commit(fetchRetailerDataSuccess, {
			key: "grabRetailerData",
			value: null
		});
	},

	[FETCH_ALL_DISTRIBUTOR_RETAILER_LIST.action]: (
		{ commit, state, rootState, dispatch },
		{ type, ...payload }
	) => {
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload,
				...(type === "end"
					? { o: state.allRetailerDstrList.offset }
					: {})
			}
		};
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getAllRetailers";

		return ApiService.post(endpoint, requestPayload)
			.then(response => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					response.statusCode === 200 &&
					typeof response.response === "object" &&
					response.response.data
				) {
					const { data, offset } = response.response;
					commit(fetchAllRetailerDstrSuccess, {
						data,
						offset,
						type
					});
					return;
				} else if (response.errMsg) {
					errMsg = response.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const errMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(SHOW_ALERT.dispatch, { text: errMsg }, { root: true });
				throw new Error(errMsg);
			});
	},
	[FETCH_ACTIVE_EXECUTIVE_UNDER_DSTR.action]: (
		{ rootState, dispatch },
		payload
	) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getActiveExecutiveUnderDstr";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (
						data.code === 200 &&
						data.response &&
						typeof data.response === "object" &&
						data.response.executivesData
					) {
						return data.response.executivesData[0] || [];
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[CREATE_RETAIL_SCHEME.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/createScheme";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					data.response.status === "success"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "Scheme Created Successfully" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPDATE_RETAIL_SCHEME.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/updateScheme";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object" &&
					data.response.status === "success"
				) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "Scheme Updated Successfully" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPLOAD_DSTR_SUPPORT_INVOICE.action]: (
		{ rootState, dispatch },
		payload
	) => {
		const { baseToUse, ...updatedPayload } = payload;
		const endpoint =
			BASE_URL + `/${baseToUse}/v1.0.0/uploadInvoiceSupportData`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...updatedPayload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "File Uploaded Successfully" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPLOAD_PRIMARY_DAY_FILE.action]: ({ rootState, dispatch }, payload) => {
		const { baseToUse, ...updatedPayload } = payload;
		const endpoint = BASE_URL + `/${baseToUse}/v1.0.0/primaryDayTargets`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...updatedPayload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "File Uploaded Successfully" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_DSTR_SUPPORT_ENTRIES.action]: ({ rootState, dispatch }, payload) => {
		const { baseToUse, ...updatedPayload } = payload;
		const endpoint =
			BASE_URL + `/${baseToUse}/v1.0.0/invoiceSupportEntries`;
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...updatedPayload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_DSTR_SUPPORT_INVOICE.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/dstrSupportInvoice";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (
					data.statusCode === 200 &&
					typeof data.response === "object"
				) {
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[REVIEW_DSTR_INVOICE.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/reviewSupportInvoiceDstr";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				let errMsg = DEFAULT_ERROR_MESSAGE;
				if (data.statusCode === 200) {
					dispatch(
						SHOW_ALERT.dispatch,
						{ text: "Invoice Signed Successfully" },
						{ root: true }
					);
					return data.response;
				} else if (data.errMsg) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	}
};

const mutations = {
	[fetchRetailerDataSuccess](state, { key, value }) {
		if (value) {
			if ("lastAppOpened" in value) {
				value["lastAppOpened"] = new Date(
					value["lastAppOpened"]
				).toLocaleDateString();
			}
			if ("createdOn" in value) {
				value["createdOn"] = new Date(
					value["createdOn"]
				).toLocaleDateString();
			}
		}
		state[key] = value;
	},
	[fetchRegistrationsSuccess](state, payload) {
		payload = payload.map(el => {
			return {
				...el,
				storeType: getFrontendStoreType(el.storeType, el.shopType)
			};
		});
		state.retailRegistrations = payload;
	},
	[takeActionOnRegistrationSuccess](state, payload) {
		// console.log(payload);
		state.retailRegistrations = state.retailRegistrations.filter(
			el => el.id !== payload.userId
		);
	},
	[fetchRetailersRankList](state, payload) {
		const { retailerRank, topRanks, lastKey, type = TOP } = payload;
		state.grabRetailerRank = retailerRank;
		if (type === TOP) {
			state.retailersTopRankList = topRanks;
		} else if (type === END) {
			state.retailersTopRankList = state.retailersTopRankList.concat(
				topRanks
			);
		}
		state.lastKey = lastKey || null;
	},
	[getQRCodePdfSuccess](state, payload) {
		state.retailerData = {
			...state.retailerData,
			qrCodePdfLink: payload.fileUrl
		};
	},
	[resetRetailModule](state) {
		Object.keys(initialState).forEach(key => {
			state[key] = initialState[key];
		});
	},
	[grabRetailerTransactionHistorySuccess](state, { array, offset, type }) {
		array = array.map(el => {
			return {
				...el,
				time: new Date(el.time).toLocaleDateString(),
				status:
					el.status === "success"
						? "1"
						: el.status === "failed"
						? 0
						: 2
			};
		});
		if (type === "end") {
			state.grabRetailerTransactionHistory = state.grabRetailerTransactionHistory.concat(
				array
			);
		} else {
			state.grabRetailerTransactionHistory = array;
		}
		state.grabRetailerTransactionHistoryOffset = offset;
	},
	[fetchAllRetailerDstrSuccess](state, { data, offset, type = TOP }) {
		data = data.map(el => {
			return {
				...el,
				storeType:
					el.userType === "dstr"
						? JEET_11_DISTRIBUTOR
						: JEET_11_PARTNER
			};
		});
		if (type === TOP) {
			state.allRetailerDstrList = {
				list: [...data],
				offset
			};
		} else if (type === END) {
			state.allRetailerDstrList = {
				list: [...state.allRetailerDstrList.list, ...data],
				offset
			};
		}
	}
};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
